import { render, staticRenderFns } from "./DashboardSwitchButtons.vue?vue&type=template&id=f178df32"
import script from "./DashboardSwitchButtons.vue?vue&type=script&lang=js"
export * from "./DashboardSwitchButtons.vue?vue&type=script&lang=js"
import style0 from "./DashboardSwitchButtons.vue?vue&type=style&index=0&id=f178df32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports